<div class="tracking-page">
  <!-- Loading -->
  @if (isLoading) {
    <div class="state-container">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  }

  <!-- Error -->
  @if (!isLoading && hasError) {
    <div class="state-container error-state">
      <mat-icon class="state-icon">error_outline</mat-icon>
      <h2>Unable to load tracking info</h2>
      <p>This link may be invalid or expired. Please <a href="https://playoctopus.com/help" target="_blank">contact support</a> for help.</p>
    </div>
  }

  <!-- Tracking content -->
  @if (!isLoading && !hasError && trackingData) {
    <main class="tracking-content">
      <div class="tracking-grid">

        <!-- Left column -->
        <div class="left-col">

          <!-- Delivery info card -->
          <div class="card delivery-card">
            <p class="section-label">ESTIMATED DELIVERY</p>
            <h1 class="delivery-date">
              {{ trackingData.estimated_delivery | date:'EEEE' | uppercase }},<br>
              {{ trackingData.estimated_delivery | date:'MMMM d' | uppercase }}
            </h1>
            <p class="delivery-msg">{{ trackingData.status_summary }}</p>

            @if (trackingData.tracking_number) {
              <div class="tracking-row">
                <p class="section-label">TRACKING NUMBER</p>
                <div class="tracking-number-row">
                  @if (trackingData.shipping_platform) {
                    <span class="carrier-badge">{{ trackingData.shipping_platform }}</span>
                  }
                  <button class="tracking-link" (click)="openTracking()">
                    {{ trackingData.tracking_number }}
                    <mat-icon class="link-icon">open_in_new</mat-icon>
                  </button>
                </div>
              </div>
            }
          </div>

          <!-- Timeline card -->
          <div class="card timeline-card">
            @for (event of timelineItems; track event.label; let last = $last) {
              <div class="timeline-item"
                   [class.is-completed]="event.is_completed"
                   [class.is-current]="event.is_current"
                   [class.is-pending]="!event.is_completed && !event.is_current">
                <div class="marker-col">
                  <div class="dot">
                    @if (event.is_completed) {
                      <mat-icon class="check-icon">check</mat-icon>
                    }
                  </div>
                  @if (!last) {
                    <div class="connector"></div>
                  }
                </div>
                <div class="event-body">
                  <p class="event-label">{{ event.label }}</p>
                  @if (event.date) {
                    <p class="event-date">
                      @if (event.is_estimated) { Estimated }
                      {{ event.date | date:'MMM d' }}
                    </p>
                  }
                  <p class="event-location" [innerHTML]="event.location"></p>
                  @if (event.recipientName) {
                    <p class="event-location">To <strong>{{ event.recipientName }}</strong></p>
                  }
                </div>
              </div>
            }
          </div>

        </div>

        <!-- Right column -->
        <div class="right-col">

          <!-- Order items card -->
          <div class="card items-card">
            @if (trackingData.order_number) {
              <h2 class="order-number">Order #{{ trackingData.order_number }}</h2>
            }
            @if ((trackingData.items?.length || trackingData.line_items?.length)) {
              <div class="items-list">
                @for (item of (trackingData.items || trackingData.line_items); track $index) {
                  <div class="item-row">
                    <div class="item-image">
                      @if (item.image_url) {
                        <img [src]="item.image_url" [alt]="item.name || item.item_name">
                      } @else {
                        <mat-icon class="placeholder-icon">image</mat-icon>
                      }
                    </div>
                    <div class="item-info">
                      <p class="item-name">{{ item.name || item.item_name }}</p>
                      <p class="item-qty">Qty {{ item.quantity }}</p>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="destination-info">
                <p class="section-label">DESTINATION</p>
                <p class="destination-address">{{ trackingData.destination.address }}</p>
              </div>
            }
          </div>

          <!-- Help card -->
          <div class="card help-card">
            <h3>Questions or a delivery issue?</h3>
            <p>Reach the Octopus team anytime at <a href="https://playoctopus.com/help" target="_blank">playoctopus.com/help</a></p>
            <button mat-stroked-button class="help-btn" (click)="openHelp()">Get help</button>
          </div>

        </div>
      </div>
    </main>
  }
</div>
